module.exports = __webpack_public_path__ + "img/sm4_livinguard_l.2f9cd6cc.png";